"use client";
import { getThemeColor } from "../get-theme-color/get-theme-color.mjs";
//#region packages/@mantine/core/src/core/MantineProvider/color-functions/get-gradient/get-gradient.ts
function getGradient(gradient, theme) {
	const merged = {
		from: gradient?.from || theme.defaultGradient.from,
		to: gradient?.to || theme.defaultGradient.to,
		deg: gradient?.deg ?? theme.defaultGradient.deg ?? 0
	};
	const fromColor = getThemeColor(merged.from, theme);
	const toColor = getThemeColor(merged.to, theme);
	return `linear-gradient(${merged.deg}deg, ${fromColor} 0%, ${toColor} 100%)`;
}
//#endregion
export { getGradient };

//# sourceMappingURL=get-gradient.mjs.map